module.exports = __webpack_public_path__ + "img/ic_minus.f69af6a2.svg";